import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  SelectDropDown
} from 'components/common/Elements/Elements';

import { createFilterCountry, createFilterSize } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  let companyCountry = [];
  let companySize = [];
  let companyRegionCountry = [];
  const numberОfFilters = 15;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  (function () {
    createFilterCountry(filters.country, companyCountry);
    createFilterSize(filters.companySize, companySize);
    createFilterCountry(filters.regionCountry, companyRegionCountry);
  })();

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.status}
        input={{ value: filter.status, onChange: handleFilter }}
        name={'status'}
        label={t('activity:filters.CUSTOMER_STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={companySize}
        input={{ value: filter.companySize, onChange: handleFilter }}
        name={'companySize'}
        label={t('activity:filters.COMPANY_SIZE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.plan}
        input={{ value: filter.plan, onChange: handleFilter }}
        name={'plan'}
        label={t('activity:filters.PRICING_PLAN')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.billingCycle}
        input={{ value: filter.billingCycle, onChange: handleFilter }}
        name={'billingCycle'}
        label={t('activity:customers.BILLING_CYCLE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={companyCountry}
        input={{ value: filter.country, onChange: handleFilter }}
        name={'country'}
        label={t('activity:filters.CUSTOMER_COUNTRY')}
        searchKeys={['value', 'findName']}
        renderKey={'fullName'}
        checkRenderKey={'fullName'}
        multi
        searchable
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.accountManager}
        input={{ value: filter.accountManager, onChange: handleFilter }}
        name={'accountManager'}
        label={t('activity:filters.ACCOUNT_MANAGER_')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.customerSuccessEngineer}
        input={{
          value: filter.customerSuccessEngineer,
          onChange: handleFilter
        }}
        name={'customerSuccessEngineer'}
        label={t('activity:about.CS_ENGINEER')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.regionName}
        input={{ value: filter.regionName, onChange: handleFilter }}
        name={'regionName'}
        label={t('activity:filters.NETWORK_REGION_NAME')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={companyRegionCountry}
        input={{ value: filter.regionCountry, onChange: handleFilter }}
        name={'regionCountry'}
        label={t('activity:filters.NET_REGION_COUNTRY')}
        searchKeys={['value', 'findName']}
        renderKey={'fullName'}
        checkRenderKey={'fullName'}
        multi
        searchable
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.providerRegionName}
        input={{ value: filter.providerRegionName, onChange: handleFilter }}
        name={'providerRegionName'}
        label={t('activity:filters.NET_PROVIDER_REGION_NAME')}
        renderKey={'label'}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.provider}
        input={{ value: filter.provider, onChange: handleFilter }}
        name={'provider'}
        label={t('activity:filters.PROVIDER')}
        renderKey={'label'}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters['tunnels.tunnelType']}
        input={{ value: filter['tunnels.tunnelType'], onChange: handleFilter }}
        name={'tunnels.tunnelType'}
        label={t('activity:filters.TUNNEL_TYPE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.networkVersion}
        input={{
          value: filter.networkVersion,
          onChange: handleFilter
        }}
        name={'networkVersion'}
        label={t('activity:filters.NETWORK_VERSION')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.gatewayImageType}
        input={{
          value: filter.gatewayImageType,
          onChange: handleFilter
        }}
        name={'gatewayImageType'}
        label={t('activity:filters.GATEWAY_IMAGE_TYPE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.gatewayImageVersion}
        input={{
          value: filter.gatewayImageVersion,
          onChange: handleFilter
        }}
        name={'gatewayImageVersion'}
        label={t('activity:filters.GATEWAY_IMAGE_VERSION')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />

      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
